// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 支付配置信息
// 标签页面
// import Labels from '@/views/label/Labels';
// 微信配置页面
// import wxconfig from '@/views/wxconfig/wxconfig';
import index from '@/views/index';
// import user from '@/views/user/userManage';
// import pushLabelManage from '@/views/user/pushLabelManage';
// import productAttributes from '@/views/product/productAttributes';
// import proceType from '@/views/product/proceType';
// import productManage from '@/views/product/productManage';
// import healthCare from '@/views/product/healthCare';
// 标签页面
// import articles from '@/views/article/articles';
// import article from '@/views/article/article';
// import papers from '@/views/paper/papers';
// import hospitals from '@/views/hospital/hospitals';
// import license from '@/views/license/LicenseManage';
import welcome from '@/views/user/welcome';
// 药品管理页面
import drug from '@/views/drug/Drugmanage';
import drugInfo from '@/views/drug/DrugInfo';
import appletIndex from '@/views/applet/index'
import appletCommon from '@/views/applet/common'

import VueRouter from "vue-router";
// 启用路由
Vue.use(Router);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: drug,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
        {
            path: '/drug/drugs',
            name: '药品管理',
            component: drug,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/drug/drugInfo',
            name: '药品详细',
            component: drugInfo,
            meta: {
                requireAuth: false
            }
        }, {
            path: '/applet/index',
            name: '小程序首页',
            component: appletIndex,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/applet/common',
            name: '小程序内链',
            component: appletCommon,
            meta: {
                requireAuth: false
            },
            children:[
                {
                    path: 'LinkHome',
                    name: 'LinkHome',
                    meta: {
                        // 之后你自己的项目中需要嵌入什么就改link属性值即可。
                        title: '哔哩哔哩',
                        link: 'https://www.bilibili.com/'
                    },
                }
            ]
        }
    ]
    // {
    //     path: '/login',
    //     name: '登录',
    //     component: login,
    //     hidden: true,
    //     meta: {
    //         requireAuth: false
    //     }
    // },
    //     {
    //     path: '/index',
    //     name: '首页',
    //     component: index,
    //     iconCls: 'el-icon-tickets',
    // children: [
    //
    // // {
    // //     path: '/label/Labels',
    // //     name: '标签管理',
    // //     component: Labels,
    // //     meta: {
    // //         requireAuth: true
    // //     }
    // // }, {
    // //     path: '/article/articles',
    // //     name: '文章管理',
    // //     component: articles,
    // //     meta: {
    // //       requireAuth: true
    // //     }
    // //   }, {
    // //     path: '/article/article',
    // //     name: '文章详情',
    // //     component: article,
    // //     meta: {
    // //       requireAuth: true
    // //     }
    // //   }, {
    // //     path: '/hospital/hospitals',
    // //     name: '任务管理',
    // //     component: hospitals,
    // //     meta: {
    // //       requireAuth: true
    // //     }
    // //   }, {
    // //     path: '/wxconfig/wxconfig',
    // //     name: '微信配置',
    // //     component: wxconfig,
    // //     meta: {
    // //         requireAuth: true
    // //     }
    // // }, {
    // //     path: '/license/LicenseManage',
    // //     name: '权限管理',
    // //     component: license,
    // //     meta: {
    // //         requireAuth: true
    // //     }
    // // }, {
    // //     path: '/user/userManage',
    // //     name: '用户管理',
    // //     component: user,
    // //     meta: {
    // //         requireAuth: true
    // //     }
    // // }, {
    // //     path: '/user/pushLabelManage',
    // //     name: '用户管理',
    // //     component: pushLabelManage,
    // //     meta: {
    // //         requireAuth: true
    // //     }
    // // }, {
    // //     path: '/product/productAttributes',
    // //     name: '产品属性管理',
    // //     component: productAttributes,
    // //     meta: {
    // //         requireAuth: true
    // //     }
    // // }, {
    // //         path: '/product/proceType',
    // //         name: '价格类别',
    // //         component: proceType,
    // //         meta: {
    // //             requireAuth: true
    // //         }
    // //     }, {
    // //         path: '/product/productManage',
    // //         name: '价格类别',
    // //         component: productManage,
    // //         meta: {
    // //             requireAuth: true
    // //         }
    // //     }, {
    // //         path: '/product/healthCare',
    // //         name: '医保分类',
    // //         component: healthCare,
    // //         meta: {
    // //             requireAuth: true
    // //         }
    // //     },{
    // //         path: '/paper/papers',
    // //         name: '文章列表',
    // //         component: papers,
    // //         meta: {
    // //             requireAuth: true
    // //         }
    // //     },
    //     {
    //         path: '/user/welcome',
    //         name: '',
    //         component: welcome,
    //         hidden: true,
    //         meta: {
    //             requireAuth: true
    //         }
    //     }]
    // }]
})





// WEBPACK FOOTER //
// ./src/router/index.js